import { ActionType } from '../../../components/modals/v2/connectors/helpers';
import {
  createConnectorAddedSuccessStep,
  createFullWidthRowLayout,
} from './connectorSchema.helpers';

export const GEMINI_AUDIT_SCOPE =
  'https://www.googleapis.com/auth/admin.reports.audit.readonly';

export const GeminiSchema = {
  name: 'Google Gemini Connector',
  steps: {
    0: {
      name: 'Step 1',
      elements: [
        {
          name: 'geminiDescription',
          type: 'description',
          description: `Cowbell reads Gemini usage from your Google Workspace audit logs. Create a Google Cloud service account, enable domain-wide delegation for it in the Google Workspace Admin console, and authorize the scope ${GEMINI_AUDIT_SCOPE}. Then enter the email of a Workspace admin the service account can impersonate and upload the service account JSON key.`,
          column: 0,
        },
        {
          name: 'adminEmail',
          label: 'Google Workspace Admin Email Address',
          description: 'Please enter your Google Workspace admin email',
          type: 'email',
          required: true,
          column: 1,
        },
        {
          name: 'customerId',
          label: 'Customer ID (optional)',
          description:
            'Leave blank to use the customer of the admin account (my_customer)',
          type: 'text',
          required: false,
          column: 2,
        },
        {
          name: 'credentials',
          label: 'Upload Service Account JSON Key',
          description:
            'The service account key is a JSON file that you downloaded from Google Cloud',
          type: 'upload',
          elementProps: { accept: ['application/json'] },
          required: true,
          column: 3,
        },
      ],
      layout: createFullWidthRowLayout(4),
      action: {
        type: ActionType.API_ENDPOINT,
        requestConfig: {
          url: '/api/connector/v1/gemini/add',
          method: 'POST',
        },
      },
    },
    1: createConnectorAddedSuccessStep(
      'Google Gemini has been successfully added as a connector. Gemini audit logs will be downloaded automatically.'
    ),
  },
};
